module.exports = __webpack_public_path__ + "static/img/error.1249a8a0.png";